import { MrbBaseViewStore } from "mrb/core";
import { observable, makeObservable, action, computed } from "mobx";

class CategoryManageSelectedItemsViewStore extends MrbBaseViewStore {
    @observable isBulk = false;

    @computed get isSelectedItemsAny() {
        return this.bulkViewStore.isSelectedItemsAny;
    }

    constructor(rootStore, bulkViewStore) {
        super(rootStore);
        makeObservable(this);
        this.bulkViewStore = bulkViewStore;
    }

    @action.bound
    changeIsBulk() {
        if (this.isUpdating) {
            return;
        }
        this.setIsBulk(!this.isBulk);
    }

    @action.bound
    setIsBulk(value) {
        this.isBulk = value;
        if (!this.isBulk) {
            this.clearSelection();
        }
    }

    @action.bound
    selectAll() {
        this.bulkViewStore.selectAll();
    }

    @action.bound
    deselectAll() {
        this.bulkViewStore.deselectAll();
    }

    resolveAccess(item) {
        throw new Error("Method not implemented.");
    }

    @action.bound
    selectItem(item) {
        const contentAccessResult = this.resolveAccess(item);
        if (contentAccessResult.canAccess) {
            this.bulkViewStore.selectItem(item);
        }
    }

    @action.bound
    deselectItem(item) {
        const contentAccessResult = this.resolveAccess(item);
        if (contentAccessResult.canAccess) {
            this.bulkViewStore.deselectItem(item);
        }
    }

    @action.bound
    async changeTurnOn(value) {
        const success = await this.bulkViewStore.changeTurnOn(value);
        if (success) {
            this.setIsBulk(false);
        }
    }

    @action.bound
    async saveSelection() {
        const success = await this.bulkViewStore.saveSelection();
        if (success) {
            this.setIsBulk(false);
        }
    }

    @action.bound
    clearSelection() {
        this.bulkViewStore.clearSelection();
    }
}

export default CategoryManageSelectedItemsViewStore;
